export const DOMAIN_COMPANIES = "COMPANIES";
